<template>
    <button id="BackButton" :class="{'Backbutton--inactive': onHomePage}" @click="navigateBack" aria-label="back">
        <IconArrowBack></IconArrowBack>
        <span>Back</span>
    </button>
</template>
<script>
import { previousRoute } from '@/router/router';

export default {
    methods: {
        navigateBack() {
            if (this.isCrosslink) {
                app.api.PageManager.navigateBack();
            } else {
                app.api.PageManager.navigateToParentScene();
            }
        },
        stripContentComponent(path) {
            return path.split(':')[0];
        }
    },
    computed: {
        onHomePage() {
            this.$route;
            return app.api.PageManager.onHomePage()
        },
        isCrosslink() {
            if (!previousRoute) 
                return false;

            const currentSegments = this.stripContentComponent(this.$route.path).split('/').filter(Boolean);
            const previousSegments = this.stripContentComponent(previousRoute.path).split('/').filter(Boolean);

            // Deep links from outside with no previous segments is not a crosslink
            if(previousSegments.length === 0)
                return false

            // Compare the segments to determine if it’s a crosslink
            for (let i = 0; i < Math.min(currentSegments.length, previousSegments.length); i++) {
                if (currentSegments[i] !== previousSegments[i]) {
                    return true;
                }
            }

            // check if it skips levels, treat it as a crosslink
            if(currentSegments.length > previousSegments.length + 1) 
                return true

            return false;
        }
    }
}
</script>
<style lang="scss" scoped>
    #BackButton {
        left: 80px;
        bottom:75px;
        width:106px;
        border-radius: 20px !important;

        span {
            position: relative;
            top:auto;
            margin:10px;
            color:var(--main-color);
            font-size:15px;
            padding:0;
        }


    }

    .Backbutton--inactive {
        opacity: 0.4;
        pointer-events: none !important;
    }
</style>